import React from 'react';
import { makeStyles } from '@material-ui/core';
import DiaLog from '../../../../components/Dialog';
import { i18n } from '../../../../language';
import ehandoverIds from '../../../../ids/Ehandover';
import { AutoCompleteInput } from '../../../../components';

const useStyles = makeStyles((theme) => ({
  title: {
    fontFamily: 'NotoSans-Medium',
    fontSize: '0.875rem',
    color: theme.palette.font.sub,
    fontWeight: '500',
    marginBottom: '0.625rem',
  },
}));

export default function CompleteTaskPopup({ open, setOpen, handleConfirm, id, name, setName, staffList }) {
  const classes = useStyles();

  return (
    <DiaLog
      open={open}
      handleClose={() => setOpen(false)}
      handleCancel={() => setOpen(false)}
      handleConfirm={handleConfirm}
      title={i18n.t('EHANDOVER_TASKITEM_SELECT_NAME')}
      cancel={i18n.t('EHANDOVER_TASKITEM_CANCEL')}
      confirm={i18n.t('EHANDOVER_TASKITEM_CONFIRM')}
      closeID={ehandoverIds.checkNote + id + 3}
      cancelID={ehandoverIds.checkNote + id + 4}
      confirmID={ehandoverIds.checkNote + id + 5}
      disabled={!name}
    >
      <div className={classes.title}>{i18n.t('EHANDOVER_TASKITEM_COMPLETED_BY')}</div>
      <AutoCompleteInput
        id={ehandoverIds.checkNote + id + 2}
        itemList={staffList}
        height="3.5rem"
        value={name}
        onChange={(props) => setName(props)}
        placeholder={i18n.t('EHANDOVER_TASKITEM_PLACEHOLDER')}
      />
    </DiaLog>
  );
}
